var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "head-image w-100 bg-cl-th-accent cl-white" },
    [
      _vm.currentImage
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy:background-image",
                  value: _vm.currentImage.image,
                  expression: "currentImage.image",
                  arg: "background-image"
                }
              ],
              staticClass: "container w-100 h-100 cl-black"
            },
            [
              _c("div", { staticClass: "head-image-content" }, [
                _c(
                  "h1",
                  {
                    staticClass: "title",
                    attrs: { "data-testid": "mainSliderTitle" }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.currentImage.title) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "subtitle mb0 serif h3",
                    attrs: { "data-testid": "mainSliderSubtitle" }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.currentImage.subtitle) +
                        "\n      "
                    )
                  ]
                )
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }